import { render } from "./BikeResultItem.vue?vue&type=template&id=4a45035d&scoped=true"
import script from "./BikeResultItem.vue?vue&type=script&lang=js"
export * from "./BikeResultItem.vue?vue&type=script&lang=js"

import "./BikeResultItem.vue?vue&type=style&index=0&id=4a45035d&lang=scss&scoped=true"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a45035d"]])

export default __exports__